import React, { useEffect } from 'react';

const SupportOpen = () => {
  useEffect(() => {
    document.title = 'ReadRivals Support';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Need help with ReadRivals, have feedback, or want to report a problem? Contact ReadRivals Support.';
  }, []);

  return (
    <main style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>ReadRivals Support</h1>
      <p>Need help with ReadRivals, have feedback, or want to report a problem?</p>
      <p>Contact us at:</p>
      <p><strong><a href="mailto:info@readwellllc.com">info@readwellllc.com</a></strong></p>
      <p>Read Rivals LLC</p>
    </main>
  );
};

export default SupportOpen;
